import React from "react";

import Paragraph from '../../Paragraph/Paragraph';
import ChallengesSection from "../ChallengesSection/ChallengesSection";
import styles from "./Challenging.module.scss";

export default function Challenging() {
  return (
    <div>
      <div className={styles['challenging-container']}>
        <Paragraph
          title="Các khó khăn và thách thức khi đưa PipFarm ra thị trường là gì?"
          content={[
            'Giành được niềm tin là phần khó khăn nhất. Các nhà giao dịch muốn biết liệu họ có thể tin tưởng những công ty mới như PipFarm hay không. Trong chưa đầy một năm, chúng tôi đã chứng minh cho hơn mười ngàn nhà giao dịch trên toàn cầu rằng họ có thể tin tưởng chúng tôi. Giờ đây, chúng tôi có một cộng đồng lớn các nhà giao dịch được cấp vốn đang thu lợi nhuận hàng ngày. Khi nhà giao dịch thấy rằng PipFarm không ngại những nhà giao dịch thành công, họ bắt đầu tin tưởng.',
          ]}
        />
      </div>
      <div className={styles['challenging-container-mobile']}>
        <Paragraph
          title="Bạn có thể chia sẻ một chút về những thành tựu mà PipFarm đã đạt được gần đây không?"
          content={[
            'Giành được niềm tin là phần khó khăn nhất. Các nhà giao dịch muốn biết liệu họ có thể tin tưởng những công ty mới như PipFarm hay không. Trong chưa đầy một năm, chúng tôi đã chứng minh cho hơn mười ngàn nhà giao dịch trên toàn cầu rằng họ có thể tin tưởng chúng tôi. Giờ đây, chúng tôi có một cộng đồng lớn các nhà giao dịch được cấp vốn đang thu lợi nhuận hàng ngày. Khi nhà giao dịch thấy rằng PipFarm không ngại những nhà giao dịch thành công, họ bắt đầu tin tưởng.',
          ]}
        />
      </div>
      <ChallengesSection />
    </div>
  );
}
